module.exports = __webpack_public_path__ + "images/FUSA_icons/023-wallet.1145e4bd75df5e1586d8be283c284724.svg";